import { Component } from '@angular/core';

@Component({
    selector: 'app-protecciondatos',
    templateUrl: './protecciondatos.component.html',
})
export class ProteccionDatosComponent {
    title = 'CEXVEG - CLÁUSULA INFORMATIVA SOBRE LA POLÍTICA DE PROTECCIÓN DE DATOS';
    p1 =
        'El Ministerio de Agricultura, Pesca y Alimentación mantiene un compromiso de cumplimiento de la legislación vigente en materia de tratamiento de datos personales y seguridad de la información con el objeto de garantizar que la recogida y tratamiento de los datos facilitados se realiza conforme al Reglamento (UE) 2016/679 General de Protección de Datos (RGPD) y de la normativa nacional vigente en la materia (Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de los Derechos Digitales). Por este motivo, le ofrecemos a continuación ';
    p1Negrita = 'información sobre la política de protección de datos ';
    p1Continuacion = 'aplicada al tratamiento de los datos de carácter personal derivado de:';
    p1l1 =
        'Registro de solicitantes para la emisión de certificados fitosanitarios para la exportación y para la solicitud de inspección fitosanitaria para la importación de vegetales y productos vegetales ';
    p1l2 = 'Registro de Entidades Auditoras';
    p1l3 = 'Registro de Operadores';

    p2title = 'INFORMACIÓN SOBRE LA POLÍTICA DE PROTECCIÓN DE DATOS';
    p2Tl1 = 'Responsable del tratamiento: ';
    p2l1 =
        'Ministerio de Agricultura, Pesca y Alimentación Dirección General de Sanidad de la Producción Agraria - Subdirección General de Acuerdos Sanitarios y Control en Frontera';
    p2l1Direccion = 'Almagro, 33. 28010 Madrid';
    p2l1Telefono = 'Teléfono 913478241';
    p2l1Email = 'Correo: ';
    p2l1Delegado = 'Delegado de Protección de datos: ';

    p2Tl2 = 'Finalidad del tratamiento: ';
    p2l2 =
        'Los datos personales incorporados se conservarán mientras la legislación aplicable obligue a su conservación (Ley 16/1985, de 25 de junio, del Patrimonio Histórico Español) y serán utilizados exclusivamente para:';

    p2th1 = 'ACTIVIDAD DE TRATAMIENTO';
    p2th2 = 'FINES DEL TRATAMIENTO';
    p2td11 =
        'Registro de solicitantes para la emisión de certificados fitosanitarios para la exportación y para la solicitud de inspección fitosanitaria para la importación de vegetales y productos vegetales';
    p2td12 =
        'Identificación de las personas autorizadas para solicitar la emisión de certificados fitosanitarios para la exportación y para la solicitud de inspección fitosanitaria para la importación de vegetales y productos vegetales';
    p2td21 = 'Registro de Entidades auditoras';
    p2td22 =
        'Identificación de las personas autorizadas por las entidades auditoras para la realización de inspecciones fitosanitarias en CEXVEG en campañas específicas de exportación ';
    p2td31 = 'Registro de Operadores';
    p2td32 =
        'Identificación de las personas autorizadas para la inscripción de parcelas y almacenes en CEXVEG que participan en campañas específicas de exportación';

    p2Tl3 = 'Legitimación del tratamiento: ';
    p2l3 =
        'el tratamiento es necesario para el cumplimiento de una misión realizada en interés público o en el ejercicio de poderes públicos conferidos al responsable del tratamiento (R(UE) 2016/2031 , de 26 de octubre, relativo a las medidas de protección contra las plagas de los vegetales).';

    p2Tl4 = 'Destinatarios de los datos: ';
    p2l4 = 'no están previstas cesiones de datos ni transferencias internacionales de datos.';

    p2Tl5 = 'Derechos sobre el tratamiento de datos: ';
    p2l51 = 'Conforme a lo previsto en el RGPD podrá solicitar al Ministerio de Agricultura, Pesca y Alimentación, a través de su sede electrónica.';
    p2l52 =
        'El acceso, rectificación y supresión de sus datos personales, la limitación y oposición al tratamiento de sus datos y a no ser objeto de decisiones automatizadas. Asimismo, si considera vulnerados sus derechos, podrá presentar una reclamación de tutela ante la Agencia Española de Protección de Datos.';
    p2l5Email = 'https://sede.mapa.gob.es/portal/site/seMAPA/navProteccionDatos';
}
